export default "__VITE_ASSET__CzP7anRB__"